module.exports = __webpack_public_path__ + "266cbd05a5a122c8908be92c23aced69.svg";